import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

interface UseAutomaticPaymentSetupReturn {
  showUnsavedModal: boolean;
  handleUnsavedConfirm: () => void;
  handleUnsavedSave: () => void;
  handleGoback: () => void;
}

export const useAutomaticPaymentSetup = (): UseAutomaticPaymentSetupReturn => {
  const [showUnsavedModal, setShowUnsavedModal] = useState(false);
  const navigate = useNavigate();

  const handleUnsavedConfirm = () => {
    navigate(-1);
  };

  const handleUnsavedSave = () => {
    setShowUnsavedModal(false);
  };

  const handleGoback = () => {
    setShowUnsavedModal(true);
  };

  return {
    showUnsavedModal,
    handleUnsavedConfirm,
    handleUnsavedSave,
    handleGoback,
  };
};
